import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { MyHead } from "../../../components/pages/MyHead";
import { Fragment } from "react";
import { NotFound } from "../../../components/pages/404/NotFound";
import {
  fetchAllArticles,
  fetchArticle,
} from "../../../services/fetch-data/useful-article-util";
import { UsefulArticleData } from "../../../hooks/react-query/useUsefulArticlesList";
import { UsefulArticlePage } from "../../../components/pages/useful-articles/useful-article-page";

export async function getStaticProps(context: any) {
  const slug: string = context.params.slug;
  console.log(slug);
  let article = undefined;
  if (!slug.includes("css"))
    article = await fetchArticle(`${context.locale}/${context.params.slug}`);

  return {
    props: {
      ...(await serverSideTranslations(context.locale, ["common"])),
      article: article || null,
    },
    revalidate: 60,
  };
}

/*
Prefetch all specialists on build
 */
export async function getStaticPaths() {
  const articles = await fetchAllArticles();
  const paths: any[] = [];
  if (articles) {
    Object.keys(articles).map((slug) => {
      paths.push({ params: { slug: slug } });
    });
  }

  return {
    paths: paths,
    fallback: "blocking", //indicates the type of fallback
  };
}

// @ts-ignore
export default function UsefulArticleEntry(params: {
  article: UsefulArticleData | null;
}) {
  const { article } = params;

  return (
    <Fragment>
      {article && (
        <Fragment>
          <MyHead
            title={article.title}
            description={`${article.title} - ${article.description}`}
            image={article.image}
            url={`/specialists/${article.urlSlug}`}
            SEODescription={article.SEODescription}
            SEOKeyword={article.SEOKeyword}
            SEOTitle={article.SEOTitle}
          />
          <UsefulArticlePage article={article} />
        </Fragment>
      )}
      {!article && <NotFound />}
    </Fragment>
  );
}
